import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
const H = window['H'];

@Component({
  selector: 'app-here-map',
  templateUrl: './here-map.component.html',
  styleUrls: ['./here-map.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class HereMapComponent implements OnInit {

  @Input()
  lat;

  @Input()
  lng;

  @ViewChild('map') mapContainer: ElementRef;
  public hereMap = null;
  public markers = [];

  @Output()
  public onMapReady: EventEmitter<any> = new EventEmitter();


  constructor() { }

  ngOnInit() {
    this.initializeMap();
  }
  initializeMap() {
    const platform = new H.service.Platform({
      app_id: 'DvkMLJUCGTNvYUfJKvjI',
      app_code: 'WCu2vYFedd98VySNf6gWWQ',
      useCIT: false,
      useHTTPS: true
    });
    const defaultLayers = platform.createDefaultLayers();
    let defaultLocation = this.lat && this.lng ? {lat: this.lat, lng: this.lng} : {  lat: 36.876874, lng: 34.063730};
    this.hereMap = new H.Map(
      this.mapContainer.nativeElement,
      defaultLayers.normal.map,
      {
        center: defaultLocation,
        pixelRatio: Math.min(2, 2),
        zoom: 12
      }
    );
    let ui = H.ui.UI.createDefault(this.hereMap, defaultLayers);
    let zoom = ui.getControl('zoom');
    zoom.setAlignment('right-bottom');

    var defaultMarker = new H.map.Marker(defaultLocation);
    this.markers.push(defaultMarker);
    this.hereMap.addObject(defaultMarker);
    this.onMapReady.emit();
  }
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/here-map/here-map.component.ts